exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-common-list{padding:0;margin:0;display:block;max-height:100%;overflow-y:auto;overflow-x:hidden;flex-shrink:1;will-change:scroll-position;touch-action:manipulation;cursor:default;user-select:none}.ba-common-list:focus{outline:none}.ba-common-list .ba-common-listItem-wrapper.is-focus{box-shadow:inset 0 0 0 2px #a8c0f3;box-shadow:inset 0 0 0 2px hsl(var(--focus-h,221),var(--focus-s,76%),var(--focus-l,81%))}", ""]);

// exports
exports.locals = {
	"menuClassName": "\"ba-common-menu\""
};